// Tiny shared defaults, split out of stores.js / mapStyles.js on purpose:
// the config screen only needs these two constants, but importing them from
// their home modules dragged ~20 KB of DEFAULT_STORES rows and Google-Maps
// style arrays into the eagerly-loaded config-screen chunk. AboutPageTab
// (which needs the real payloads) keeps importing the full modules.
export const DEFAULT_HOURS_SEPARATOR = ', ';
export const MAP_SETTINGS_DEFAULT = { multi: false, position: 'bottom', zoom: 14, zoomMax: 16, style: '[]' };
